import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/components/views/home.vue'
import NotFoundView from '@/components/views/NotFound.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('@/components/views/faq.vue')
    },
    {
        path: '/Support',
        name: 'Support',
        component: () => import('@/components/views/Support.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/components/views/aboute.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/components/views/contact.vue')
    },
    {
        path: '/blog',
        name: 'blog',
        component: () => import('@/components/views/blog.vue')
    },
    {
        path: '/templates',
        name: 'templates',
        component: () => import('@/components/views/templates.vue')
    },
    {
        path: '/plane',
        name: 'plane',
        component: () => import('@/components/views/plane.vue')
    },
    {
        path: '/blog/:slug',
        name: 'blogdetale',
        component: () => import('@/components/views/blogdetale.vue')
    },
    {
        path: '/features',
        name: 'features',
        component: () => import('@/components/views/features.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFoundView
    }
]

// ایجاد router
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

export default router